export default {
  fillOpacity: 0.3,
  strokeOpacity: 0.7
}

export const hover = {
  fillOpacity: 0.5,
  strokeOpacity: 0.7
}
